import _ from 'lodash';
import ApplicationRecord from './ApplicationRecord';
/**
 * Abstract class for Reference
 * @return {Class} Class to extends.
 */
export default function(ChildClass, attributes) {
  return class AbstractReferenceSection extends ApplicationRecord(
    _.merge(attributes, {
      ID: -1,
      _embedded: {},
    })
  ) {};
}



// WEBPACK FOOTER //
// ./src/models/AbstractReferenceSection.js